import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { notify } from "../../helpers/commonFunctions";
import { routes } from "../../helpers/constants";
import Loader from "../../components/Loader";
import LoginLeftBg from "../../assets/images/login-left-bg.png";
import LoginRightTopBg from "../../assets/images/login-right-top-bg.png";
import LoginRightBottomBg from "../../assets/images/Right-bottom.png";
import signLogo from "../../assets/images/signLogo.png";
import forgotPassword from "../../assets/images/forgotPassword2.png";
import { BackArrowBlue, BackArrowIcon, emailIcon } from "../../assets/icons";
import { reqtoTwoFAVerify } from "../../redux/slices.js/authentication/authenticationSlice";
import { logout } from "../../redux/slices.js/admins/adminsSlice";

const VerifyAuth = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loader = useSelector((state) => state.authentication.loader);

  const [showRecovery, setShowRecovery] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [recoveryCode, setRecoveryCode] = useState("");

  const handleOtpChange = (value, index) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 5) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "" && index > 0) {
        document.getElementById(`otp-${index - 1}`).focus();
      } else {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      }
    }
    if (e.key === "ArrowLeft" && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
    if (e.key === "ArrowRight" && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleOtpVerify = () => {
    const token = otp.join("");
    if (token.length !== 6) {
      notify("Please enter a valid 6-digit code", "error");
      return;
    }

    dispatch(
      reqtoTwoFAVerify({
        token,
        onSuccess: (res) => {
          notify(res?.data?.message || "Verification successful", "success");
          navigate(routes.dashboard);
        },
        onFailure: () => { },
      })
    );
  };

  const handleRecoveryVerify = () => {
    if (!recoveryCode.trim()) {
      notify("Please enter your recovery code", "error");
      return;
    }

    dispatch(
      reqtoTwoFAVerify({
        token: recoveryCode.trim(),
        action: "backup_code",
        onSuccess: (res) => {
          notify(
            res?.data?.message || "Recovery code verification successful",
            "success"
          );
          navigate(routes.dashboard);
        },
        onFailure: () => { },
      })
    );
  };

  const handleBack = () => {
    dispatch(logout());
  };

  return (
    <>
      {loader && <Loader />}
      <div className="signup-page bg-white">
        {/* <button
          type="button"
          aria-label="Go back"
          onClick={() => navigate(-1)}
          className="cursor-pointer"
        >
          {BackArrowIcon}
        </button> */}
        <div className="container">
          <div className="signup-container h-screen flex items-center flex-wrap relative">
            <div className="py-3 w-full lg:w-1/2 h-full hidden lg:flex">
              <div className="signup-left w-full h-full lg:flex items-start justify-between flex-col  bg-blue relative rounded-[30px]">
                <img
                  src={LoginLeftBg}
                  alt="LoginLeftBg"
                  className="absolute left-0 top-0 z-0"
                />
                <img
                  src={LoginRightTopBg}
                  alt="LoginRightTopBg"
                  className="absolute right-0 top-0 z-0"
                />
                <img
                  src={LoginRightBottomBg}
                  alt="LoginRightBottomBg"
                  className="absolute right-0 bottom-0 z-0"
                />
                <div className="signUpText flex flex-col gap-5 ps-[45px] pt-[35px]">
                  <img src={signLogo} className="max-w-[168px]" alt="" />
                </div>
                <img
                  src={forgotPassword}
                  alt="otp"
                  className="mb-0 object-contain w-auto h-[70%] z-0"
                />
              </div>
            </div>

            <div
              className={`signup-right overflow-auto w-full lg:w-1/2 mx-auto md:px-[70px] h-full py-10 flex items-center justify-center flex-col px-4 relative`}
            >
              <div className="backArrow absolute md:left-[70px] top-10 left-4">
                <button
                  type="button"
                  aria-label="Go back"
                  onClick={() => navigate(-1)}
                  className="cursor-pointer"
                >
                  {BackArrowIcon}
                </button>
              </div>
              <div className="signup-right-title pb-[53px]">
                <div
                  className=" w-[84px] h-[84px]
    border-[16px] border-[#E3EAF9]
    rounded-full
    flex items-center justify-center
    mx-auto mb-[20px]"
                >
                  {emailIcon}
                </div>
                <h1 className="font-roboto mb-2 text-center text-black  inner-title">
                  Two-Factor Verification
                </h1>
                <p className="text-p mb-0 text-gray w-90 text-center">
                  {
                    !showRecovery
                      ? "Enter the 6-digit verification code from your authenticator app."
                      : "Enter the recovery code from your backup code."
                  }

                </p>
              </div>

              <div className={` w-full lg:max-w-lg space-y-4 pb-5`}>
                {!showRecovery ? (
                  <>
                    <div className="flex items-center justify-center gap-4">
                      {otp.map((digit, i) => (
                        <input
                          key={i}
                          id={`otp-${i}`}
                          type="text"
                          maxLength="1"
                          value={digit}
                          onChange={(e) => handleOtpChange(e.target.value, i)}
                          onKeyDown={(e) => handleOtpKeyDown(e, i)}
                          className={`!w-12 !h-12 text-center border rounded text-lg font-semibold focus:outline-none focus:border-blue ${digit ? 'border-black' : 'border-gray-300'
                            }`}
                        />
                      ))}
                    </div>

                    <div className="pt-5 text-center !mt-auto">
                      <button onClick={handleOtpVerify} className="btn-yellow">
                        Verify
                      </button>
                    </div>

                    <p
                      onClick={() => setShowRecovery(true)}
                      className="mt-4 text-[#787891] hover:text-blue-500 cursor-pointer underline text-center"
                    >
                      Use recovery code instead
                    </p>

                    <p
                      onClick={() => navigate("/login")}
                      className="mt-4 text-[#787891] hover:text-blue-500 cursor-pointer text-center flex items-center gap-1 justify-center"
                    >
                      {BackArrowIcon}
                      Back To Login
                    </p>
                  </>
                ) : (
                  <>
                    <input
                      type="text"
                      value={recoveryCode}
                      onChange={(e) => setRecoveryCode(e.target.value)}
                      placeholder="Enter your recovery code"
                      className="w-full h-12 text-center border border-gray-300 rounded text-lg focus:outline-none focus:border-blue"
                    />

                    <div className="pt-5 text-center !mt-auto">
                      <button
                        onClick={handleRecoveryVerify}
                        className="btn-yellow"
                      >
                        Verify
                      </button>
                    </div>

                    <p
                      onClick={() => setShowRecovery(false)}
                      className="mt-4 text-[#787891] hover:text-blue-500 cursor-pointer underline text-center"
                    >
                      Use authenticator code instead
                    </p>
                    <p
                      onClick={() => navigate("/login")}
                      className="mt-4 text-[#787891] hover:text-blue-500 cursor-pointer text-center flex items-center gap-1 justify-center"
                    >
                      {BackArrowIcon}
                      Back To Login
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyAuth;
